import {
	comMapping
} from '../../../../util/Function/comMapping.js'
export function getdata() {
	var obj = {
		searchlist: [

			{
				"label": "公司代码",
				"prop": "companyCode",
				type: "input"
			},
			{
				"label": "所属期",
				"prop": "suosq",
				type: "datemonth",
				valueformat: 'yyyyMM'
			},
			{
				"label": "专用缴款书号码",
				"prop": "zhuanyjkshm",
				type: "input"
			},
			{
				"label": "进口口岸代码",
				"prop": "jinkkadm",
				type: "input"
			},
			{
				"label": "进口口岸名称",
				"prop": "jinkkamc",
				type: "input"
			},
			{
				"label": "填发日期",
				"prop": "tianfrq",
				type: "datemonth",
				valueformat: 'yyyyMM'
			},
			{
				"label": "税款金额",
				"prop": "shuikje",
				type: "inputplus"
			},
			{
				"label": "备注",
				"prop": "beiz",
				type: "input"
			},
			{
				"label": "作废状态",
				"prop": "zuofzt",
				type: "select",
				selectval: [{
					label: "已作废",
					value: "1"
				}, {
					label: "未作废",
					value: "0"
				}],
			},
			{
				"label": "认证标识",
				"prop": "renzbs",
				type: "select",
				selectval: [{
					label: "已认证",
					value: "1"
				}, {
					label: "未认证",
					value: "0"
				}],
			},
			{
				"label": "认证日期",
				"prop": "gouxrq",
				type: "datemonth",
				valueformat: 'yyyyMM'
			},
			{
				"label": "认证有效税款金额",
				"prop": "renzyxskje",
				type: "inputplus"
			},
			{
				"label": "认证用途",
				"prop": "renzyt",
				type: "select",
				selectval: [{
					label: "退税",
					value: "1"
				}, {
					label: "抵扣",
					value: "0"
				}],
			},
			{
				"label": "收入机关",
				"prop": "shourjg",
				type: "input"
			},
			{
				"label": "缴款单位一名称",
				"prop": "jiaokdwymc",
				type: "input"
			},
			{
				"label": "缴款单位二名称",
				"prop": "jiaokdwemc",
				type: "input"
			},
			{
				"label": "缴款单位一税号",
				"prop": "jiaokdwysh",
				type: "input"
			},
			{
				"label": "缴款单位二税号",
				"prop": "jiaokdwesh",
				type: "input"
			},
			{
				"label": "一级关区代码",
				"prop": "yijgqdm",
				type: "input"
			},
			{
				"label": "报送文件标识",
				"prop": "baoswjbs",
				type: "input"
			},
			{
				"label": "申请单位编码",
				"prop": "shenqdwbm",
				type: "input"
			},
			{
				"label": "报关单编码",
				"prop": "baogdbm",
				type: "input"
			},
			{
				"label": "贸易方式",
				"prop": "maoyfs",
				type: "input"
			},
			{
				"label": "预算科目代码",
				"prop": "yuskmdm",
				type: "input"
			},
			{
				"label": "收款国库代码",
				"prop": "shoukgkdm",
				type: "input"
			},
			{
				"label": "运输工具",
				"prop": "yunsgj",
				type: "input"
			},
			{
				"label": "缴款期限",
				"prop": "jiaokqx",
				type: "input"
			},
			{
				"label": "提运单号",
				"prop": "tiydh",
				type: "input"
			},
			{
				"label": "批次号",
				"prop": "pich",
				type: "input"
			},

		],
		searchdata: {
			shuikje: [],
			renzyxskje: []
		},
		headData: [{
				title: "公司代码",
				prop: "companyCode",
				width: 80,
				custom: true,

			},
			{
				title: "所属期",
				prop: "suosq",
				width: 80,
				custom: true,

			},
			{
				title: "专用缴款书号码",
				prop: "zhuanyjkshm",
				width: 120,
				custom: true,

			},
			{
				title: "填发日期",
				prop: "tianfrq",
				custom: true,

			},
			{
				title: "税款金额",
				prop: "shuikje",
				width: 80,
				custom: true,
			},
			{
				title: "作废状态",
				prop: "zuofzt",
				custom: true,
			},
			{
				title: "认证标识",
				prop: "renzbs",
				custom: true,
			},
			{
				title: "认证日期",
				prop: "gouxrq",
				width: 80,
				custom: true,

			},
			{
				title: "认证有效税款金额",
				prop: "renzyxskje",
				width: 120,
				AmountFormat: true,
				custom: true,

			},
			{
				title: "认证用途",
				prop: "renzyt",
				custom: true,
			},
			{
				title: "批次号",
				prop: "pich",
				width: 160,
				custom: true,

			}
		],
		hideHeadData: [{
				"title": "进口口岸代码",
				"prop": "jinkkadm"
			},
			{
				"title": "进口口岸名称",
				"prop": "jinkkamc"
			},
			{
				"title": "备注",
				"prop": "beiz"
			},
			{
				"title": "收入机关",
				"prop": "shourjg"
			},
			{
				"title": "缴款单位一名称",
				"prop": "jiaokdwymc"
			},
			{
				"title": "缴款单位二名称",
				"prop": "jiaokdwemc"
			},
			{
				"title": "缴款单位一税号",
				"prop": "jiaokdwysh"
			},
			{
				"title": "缴款单位二税号",
				"prop": "jiaokdwesh"
			},
			{
				"title": "一级关区代码",
				"prop": "yijgqdm"
			},
			{
				"title": "报送文件标识",
				"prop": "baoswjbs"
			},
			{
				"title": "申请单位编码",
				"prop": "shenqdwbm"
			},
			{
				"title": "报关单编码",
				"prop": "baogdbm"
			},
			{
				"title": "贸易方式",
				"prop": "maoyfs"
			},
			{
				"title": "预算科目代码",
				"prop": "yuskmdm"
			},
			{
				"title": "收款国库代码",
				"prop": "title"
			},
			{
				"title": "运输工具",
				"prop": "yunsgj"
			},
			{
				"title": "缴款期限",
				"prop": "jiaokqx"
			},
			{
				"title": "提运单号",
				"prop": "tiydh"
			}
		],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
		syncForm: {
			issueDate: '',
			issueStart: '',
			issueEnd: ''
		},
	}
	return obj
}
